import { invokeApiGateway } from '../../auth/api-client';

export type LogLevel = 'INFO' | 'WARN' | 'ERROR' | 'DEBUG';
export type LogGroup = 'cs-proxy' | 'cs-worker' | 'cs3-service' | 'bedrock-agentcore' | 'athena-query' | 'estimator';
export type TimeRange = '1h' | '6h' | '24h' | '7d';

export interface LogEntry {
  timestamp: number;
  message: string;
  logStreamName: string;
  level?: string;
  requestId?: string;
}

export async function listLogGroups(env: string) {
  return invokeApiGateway(`/debug/logs/groups?env=${env.toLowerCase()}`);
}

export async function searchLogs(
  env: string,
  params: { logGroup: string; filterPattern?: string; startTime?: number; endTime?: number; limit?: number },
) {
  return invokeApiGateway(`/debug/logs/search?env=${env.toLowerCase()}`, 'POST', params);
}

function timeRangeToMs(range: TimeRange): number {
  const map: Record<TimeRange, number> = { '1h': 3600000, '6h': 21600000, '24h': 86400000, '7d': 604800000 };
  return map[range];
}

export async function fetchLogs(
  logGroup: string,
  timeRange: TimeRange,
  filterPattern: string,
  env: string,
): Promise<LogEntry[]> {
  const now = Date.now();
  const result = await searchLogs(env, {
    logGroup,
    filterPattern: filterPattern || undefined,
    startTime: now - timeRangeToMs(timeRange),
    endTime: now,
    limit: 200,
  });
  return (result.events || []).map((e: any) => ({
    timestamp: e.timestamp,
    message: e.message,
    logStreamName: e.logStreamName || '',
    level: e.message?.includes('ERROR') ? 'ERROR' : e.message?.includes('WARN') ? 'WARN' : 'INFO',
  }));
}